import requests from "./api/api";

const TicketService = {

    getMyTickets: () => requests.get('/ticket/v1/get-my-ticket-list-user'),
    getTicketMessages: (ticket_id) => requests.get(`/ticket/v1/get-ticket-messages-user/${ticket_id}`),
    answerTicket: (body) => requests.put('/ticket/v1/user-answer-ticket', body),
};

export default TicketService;
